import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import PageNotFound from "../modules/page-not-found";
import PrivateRouter from "./PrivateRouter";
import PublicRouter from "./PublicRouter";
import SignIn from "../modules/auth/sign-in/SignIn";
import Dashboard from "../modules/pages/dashboard/Dashboard";
import ResetPassword from "../modules/auth/reset-password/ResetPassword";
import ForgotPassword from "../modules/auth/forgot-password/ForgotPassword";
import VerifyOtp from "../modules/auth/verify-otp/VerifyOtp";
import TenantMgmnt from "../modules/pages/tenant-mgmnt/TenantMgmnt";
import Advertising from "../modules/pages/advertising/Advertising";
import CmsMgmnt from "../modules/pages/cms-mgmnt/CmsMgmnt";
import ManageSubscription from "../modules/pages/manage-subscription/ManageSubscription";
import ManagePodcast from "../modules/pages/podcast-mgmnt/manage-podcast/ManagePodcast";
import ManageCategory from "../modules/pages/podcast-mgmnt/manage-category/ManageCategory";
import ManageAuthors from "../modules/pages/podcast-mgmnt/manage-authors/ManageAuthors";
import ManageHomeCategory from "../modules/pages/podcast-mgmnt/manage-home-category/ManageHomeCategory";
import AddTenent from "../modules/pages/tenant-mgmnt/AddTenent";
import AddPodcast from "../modules/pages/podcast-mgmnt/manage-podcast/AddPodcast";
import AddCategory from "../modules/pages/podcast-mgmnt/manage-category/AddCategory";
import AddHomeCategory from "../modules/pages/podcast-mgmnt/manage-home-category/AddHomeCategory";
import ManageCelebrity from "../modules/pages/podcast-mgmnt/manage-celebrity/ManageCelebrity";
import AddAuthors from "../modules/pages/podcast-mgmnt/manage-authors/AddAuthors";
import AddCelebrity from "../modules/pages/podcast-mgmnt/manage-celebrity/AddCelebrity";
import AddSubscription from "../modules/pages/manage-subscription/AddSubscription";
import AddAdvertising from "../modules/pages/advertising/AddAdvertising";
import ViewTenantDetails from "../modules/pages/tenant-mgmnt/ViewTenantDetails";
import ViewCelebrityDetails from "../modules/pages/podcast-mgmnt/manage-celebrity/ViewCelebrityDetails";
import ViewAuthorDetails from "../modules/pages/podcast-mgmnt/manage-authors/ViewAuthorDetails";
import ViewPodcast from "../modules/pages/podcast-mgmnt/manage-podcast/ViewPodcast";
import ScromPlayerFun from "../modules/scrom/ScromPlayerFun";
import ViewTenantUser from "../modules/pages/tenant-mgmnt/ViewTenantUser";
import NotificationComp from "../modules/pages/notification/NotificationComp";
import NotificationList from "../modules/pages/notification/NotificationList";
import { urlConstant } from "../constants/urlConstant";
import ViewNotify from "../modules/pages/notification/ViewNotify";
import AllQueries from "../modules/pages/dashboard/queries/AllQueries";
import ViewQueryData from "../modules/pages/dashboard/queries/ViewQueryData";
import UserActivityList from "../modules/pages/dashboard/activityLogs/UserActivityList";
import AddAudio from "../modules/pages/podcast-mgmnt/manage-audio/AddAudio";

export default function MainRoute() {
  return (
    <>
      <Routes>
        <Route path="/" element={<PublicRouter />}>
          <Route path="/" element={<SignIn />} />
          <Route path="/course" element={<ScromPlayerFun />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
        </Route>
        <Route path="/" element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path={urlConstant?.notification}
            element={<NotificationList />}
          />
          <Route
            path={urlConstant?.addNotification}
            element={<NotificationComp />}
          />
          <Route
            path={urlConstant?.viewNotification}
            element={<ViewNotify />}
          />
          <Route path={"/queries"} element={<AllQueries />} />
          <Route path={"/user-activity"} element={<UserActivityList />} />
          <Route path={"/queries/view"} element={<ViewQueryData />} />
          <Route path="/tenant-mgmnt" element={<TenantMgmnt />} />
          <Route path="/tenant-mgmnt/add-tenant" element={<AddTenent />} />
          <Route path="/tenant-mgmnt/edit-tenant" element={<AddTenent />} />
          <Route
            path="/tenant-mgmnt/view-tenant"
            element={<ViewTenantDetails />}
          />
          <Route
            path="/tenant-mgmnt/view-tenant/user/view"
            element={<ViewTenantUser />}
          />
          <Route path="/advertising" element={<Advertising />} />
          <Route
            path="/advertising/add-advertisement"
            element={<AddAdvertising />}
          />
          <Route path="/cms-mgmnt" element={<CmsMgmnt />} />
          <Route path="/manage-subscription" element={<ManageSubscription />} />
          <Route
            path="/manage-subscription/add-subscription"
            element={<AddSubscription />}
          />
          <Route
            path="/manage-subscription/edit-subscription"
            element={<AddSubscription />}
          />
          <Route path="/manage-podcast" element={<ManagePodcast />} />
          <Route
            path="/manage-podcast/view-podcast"
            element={<ViewPodcast />}
          />
          <Route path="/manage-podcast/add-podcast" element={<AddPodcast />} />
          <Route path="/manage-category" element={<ManageCategory />} />
          <Route
            path="/manage-category/add-category"
            element={<AddCategory />}
          />
           <Route path="/manage-audio" element={<AddAudio />} />
          <Route path="/manage-authors" element={<ManageAuthors />} />
          <Route path="/manage-authors/add-authors" element={<AddAuthors />} />
          <Route
            path="/manage-authors/edit-author/:id"
            element={<AddAuthors />}
          />
          <Route
            path="/manage-authors/view-author/:id"
            element={<ViewAuthorDetails />}
          />
          <Route
            path="/manage-home-category"
            element={<ManageHomeCategory />}
          />
          <Route
            path="/manage-home-category/add-home-category"
            element={<AddHomeCategory />}
          />
          <Route
            path="/manage-home-category/edit-home-category"
            element={<AddHomeCategory />}
          />
          <Route path="/manage-celebrity" element={<ManageCelebrity />} />
          <Route
            path="/manage-celebrity/view-celebrity"
            element={<ViewCelebrityDetails />}
          />

          <Route
            path="/manage-celebrity/add-celebrity"
            element={<AddCelebrity />}
          />
          <Route
            path="/manage-celebrity/edit-celebrity"
            element={<AddCelebrity />}
          />
        </Route>
      </Routes>
    </>
  );
}
